import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config";
import {log} from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

export const getClientServiceQuarantineDurations = async (token, clientServiceId) => {
    log("welcome in getClientServiceQuarantineDurations")

    if (!token || token === "") {
        return {error: true, message: "No token provided", durations: []}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_client_service_quarantine_durations_api'
        if (clientServiceId) {
            url += `?client_service_id=${clientServiceId}`
        }
        const result = await axios.get(url, {headers: headers})
        return result.data
    } catch (err) {
        log("Error in getClientServiceQuarantineDurations")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getClientServiceQuarantineDurations", durations: []}
    }
}

export const addClientServiceQuarantineDuration = async (token, data) => {
    log("welcome in addClientServiceQuarantineDuration")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/add_client_service_quarantine_duration_api'
        const payload = {
            client_service_id: data.client_service_id,
            property_type: data.property_type,
            billing_period_id: data.billing_period_id,
            quarantine_value: data.quarantine_value,
            active: data.active !== false
        }

        const result = await axios.post(url, payload, {headers: headers})
        return result.data
    } catch (err) {
        log("Error in addClientServiceQuarantineDuration")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la addClientServiceQuarantineDuration"}
    }
}

export const updateClientServiceQuarantineDuration = async (token, data) => {
    log("welcome in updateClientServiceQuarantineDuration")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/update_client_service_quarantine_duration_api'
        const payload = {
            id: data.id,
            client_service_id: data.client_service_id,
            property_type: data.property_type,
            billing_period_id: data.billing_period_id,
            quarantine_value: data.quarantine_value,
            active: data.active
        }

        const result = await axios.put(url, payload, {headers: headers})
        return result.data
    } catch (err) {
        log("Error in updateClientServiceQuarantineDuration")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la updateClientServiceQuarantineDuration"}
    }
}

export const deleteClientServiceQuarantineDuration = async (token, id) => {
    log("welcome in deleteClientServiceQuarantineDuration")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/delete_client_service_quarantine_duration_api'
        const result = await axios.delete(url, {headers: headers, data: {id: id}})
        return result.data
    } catch (err) {
        log("Error in deleteClientServiceQuarantineDuration")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la deleteClientServiceQuarantineDuration"}
    }
}

export default () => {
    return {
        error,
        getClientServiceQuarantineDurations,
        addClientServiceQuarantineDuration,
        updateClientServiceQuarantineDuration,
        deleteClientServiceQuarantineDuration
    }
}
